/**
 * @flow
 */
'use strict';

export const santeGeneraleCodes = [
{"code":"A cessé de fumer"},
{"code":"A.V.C."},
{"code":"AB"},
{"code":"Acariens"},
{"code":"Accou"},
{"code":"Accouchement il y a 1 an"},
{"code":"Accouchement il y a 3 ans"},
{"code":"Acnée"},
{"code":"Acouphène"},
{"code":"Adénome"},
{"code":"Alimentaires"},
{"code":"Allaitement"},
{"code":"Allergie PNC"},
{"code":"Allergie saisonnière"},
{"code":"Alopecie/apelade"},
{"code":"Alzheimer"},
{"code":"Amoxil"},
{"code":"Amputation jambe"},
{"code":"Anevrysme"},
{"code":"Angine"},
{"code":"Animaux"},
{"code":"Anovulant"},
{"code":"Anti-cancer"},
{"code":"Anti-coagulant"},
{"code":"Anti-douleur"},
{"code":"Anti-fongique"},
{"code":"Anti-hormone"},
{"code":"Anti-inflammatoire"},
{"code":"Antidepresseur"},
{"code":"Anxiolytique"},
{"code":"Anxiété"},
{"code":"Anémie"},
{"code":"Apnée du sommeil"},
{"code":"Apnée sommeil"},
{"code":"Appareil auditif"},
{"code":"Arachides"},
{"code":"Arthrite"},
{"code":"Arthrite juvénile"},
{"code":"Arthrite psoriatique"},
{"code":"Arthrite rhumatoide"},
{"code":"Arthrite rhumatoïde ???"},
{"code":"Arthrite sacro-illiaque"},
{"code":"Arthrose"},
{"code":"Artérosclérose"},
{"code":"Arythmie"},
{"code":"Arythmie cardiaque"},
{"code":"Asperger"},
{"code":"Aspirine"},
{"code":"Asthme"},
{"code":"Asthme durant rhume"},
{"code":"Asthme, angine"},
{"code":"Atrophie cortex post."},
{"code":"Autisme"},
{"code":"Autisme/asperger"},
{"code":"Basocellulaire"},
{"code":"Basse pression"},
{"code":"Beta thalassemie"},
{"code":"Biaxin"},
{"code":"Bipolaire"},
{"code":"Bonne"},
{"code":"Bonne santé général"},
{"code":"Bonne santé générale"},
{"code":"Borderline"},
{"code":"Bronchite"},
{"code":"Cancer"},
{"code":"Cancer aux poumons"},
{"code":"Cancer aux reins"},
{"code":"Cancer cerveau"},
{"code":"Cancer de la peau"},
{"code":"Cancer du colon"},
{"code":"Cancer du sein"},
{"code":"Cancer gorge"},
{"code":"Cancer moëlle"},
{"code":"Cancer ovaire"},
{"code":"Cancer pancréas"},
{"code":"Cancer poumon"},
{"code":"Cancer prostate"},
{"code":"Cancer sein"},
{"code":"Cancer thyroide"},
{"code":"Cathétérisme cardiaque"},
{"code":"Cefzil"},
{"code":"Chats"},
{"code":"Cheveu de mouton"},
{"code":"Chimio"},
{"code":"Choc post traumatique"},
{"code":"Choles., HTN"},
{"code":"Choles., HTN, coeur"},
{"code":"Choles.limite"},
{"code":"Cholesterol"},
{"code":"Cholesterol ?"},
{"code":"Cholesterol, coeur"},
{"code":"Chx bariatrique"},
{"code":"Chx genoux"},
{"code":"Chx hanche"},
{"code":"Chx thyroide"},
{"code":"Circulation"},
{"code":"Cirrhose"},
{"code":"Claustrophobie"},
{"code":"Clindamycine"},
{"code":"Coeur"},
{"code":"Coeur, HTN"},
{"code":"Colite ulcéreuse"},
{"code":"Colon irritable"},
{"code":"Colorant alimentaire"},
{"code":"Colôn irritable"},
{"code":"Comotion cérébrale"},
{"code":"Concentration"},
{"code":"Connue migrainneuse"},
{"code":"Copd"},
{"code":"Cortisone"},
{"code":"Couperose"},
{"code":"Crise angine"},
{"code":"Crise panique"},
{"code":"Crohn + arthrite"},
{"code":"DB type 1"},
{"code":"DB type 2"},
{"code":"Db type II"},
{"code":"Debalancement hormonal"},
{"code":"Defibrilateur"},
{"code":"Deficience intellectuelle"},
{"code":"Demence"},
{"code":"Depression"},
{"code":"Depression majeure"},
{"code":"Dermatomyosite"},
{"code":"Dermographisme"},
{"code":"Diab. ? attente résultat"},
{"code":"Diab. borderline"},
{"code":"Diabete grossesse"},
{"code":"Diabète"},
{"code":"Diabète 1"},
{"code":"Diabète II"},
{"code":"Dialyse"},
{"code":"Diverticulite"},
{"code":"Dormir"},
{"code":"Douleur dos"},
{"code":"Douleurs chroniques"},
{"code":"Dyslexie"},
{"code":"Dysorthographie"},
{"code":"Dysphagie"},
{"code":"Dysphasie sévère"},
{"code":"Dyspraxie"},
{"code":"Dystonie cervicale"},
{"code":"Dystrophie musculaire"},
{"code":"Dystrophie oculo pharyngée"},
{"code":"Dystrophie sympathique reflexe"},
{"code":"Déficit attention"},
{"code":"Démence vasculaire"},
{"code":"Dépression"},
{"code":"Développement normal"},
{"code":"Eczéma"},
{"code":"Emphysème"},
{"code":"Enceinte"},
{"code":"Endometriose"},
{"code":"Entorse cervicale"},
{"code":"Entorse lombaire"},
{"code":"Epilepsie"},
{"code":"Erythromycine"},
{"code":"Estomac"},
{"code":"Fatigue "},
{"code":"Fertilité"},
{"code":"Fibrillation cardiaque"},
{"code":"Fibrome"},
{"code":"Fibromyalgie"},
{"code":"Fibrose kystique"},
{"code":"Fibrose pulmonaire"},
{"code":"Fievre des foins"},
{"code":"Foie"},
{"code":"Fruits de mer"},
{"code":"Fumeur"},
{"code":"Fumeuse"},
{"code":"Glycorabdomyalise"},
{"code":"Glycémie borderline"},
{"code":"Goutte"},
{"code":"Goître"},
{"code":"Greffe foie"},
{"code":"Greffe moelle osseuse"},
{"code":"Greffe pancreas"},
{"code":"Greffe rein"},
{"code":"Grossesse"},
{"code":"HIV +"},
{"code":"HTN "},
{"code":"HTN limite"},
{"code":"HTN, choles"},
{"code":"HTN, choles."},
{"code":"HTN, coeur"},
{"code":"HTN, pb thyroïde, chol."},
{"code":"HTN, thyroide"},
{"code":"HTN?"},
{"code":"Handicap intellectuel"},
{"code":"Hepatite autoimmune"},
{"code":"Hernie discale"},
{"code":"Hormonotherapie"},
{"code":"Hx cancer"},
{"code":"Hydrocéphalie"},
{"code":"Hydromorphone"},
{"code":"Hyperactivité"},
{"code":"Hypercholesterol"},
{"code":"Hypercholestomie"},
{"code":"Hyperthyroidie"},
{"code":"Hypertrophie prostate"},
{"code":"Hypophyse"},
{"code":"Hypotension"},
{"code":"Hypothyroïdie"},
{"code":"Hysterectomie"},
{"code":"Hépatite B"},
{"code":"Hépatite autoimmune"},
{"code":"Infarctus"},
{"code":"Inflammation abdomen"},
{"code":"Insomnie"},
{"code":"Insuffisance cardiaque"},
{"code":"Insuffisance rénale"},
{"code":"Intolérance gluten"},
{"code":"Intolérance lactose"},
{"code":"Iode"},
{"code":"Jambe sans repos"},
{"code":"Kyste cerveau"},
{"code":"Kyste thyroide"},
{"code":"Labyrinthite"},
{"code":"Latex"},
{"code":"Leucémie"},
{"code":"Leucémie latente"},
{"code":"Limite Sjogren"},
{"code":"Limite osteoporose"},
{"code":"Low platelet count"},
{"code":"Lupus"},
{"code":"Lymphome"},
{"code":"MPOC"},
{"code":"Maladie coeliaque"},
{"code":"Maladie crohn"},
{"code":"Maladie d osgood schlatter"},
{"code":"Maladie de Crohn"},
{"code":"Maladie de Graves"},
{"code":"Maladie de renaud"},
{"code":"Maladie des os"},
{"code":"Maladie dégénérative"},
{"code":"Maladie inflammatoire ?"},
{"code":"Maladie meunière"},
{"code":"Maladie wegener"},
{"code":"Maux de tête"},
{"code":"Mdet"},
{"code":"Mdet + fréquent"},
{"code":"Mdet 2ndr Nerf Arnold"},
{"code":"Mdet assez fréquent"},
{"code":"Mdet fin de journée"},
{"code":"Mdet le matin"},
{"code":"Mdet nuit"},
{"code":"Mdet occasionnel"},
{"code":"Mdet occasionnelle"},
{"code":"Mdet rare"},
{"code":"Mdet s Rx"},
{"code":"Mdet/migraine"},
{"code":"Mdet/étourdissement"},
{"code":"Mdt occasionnel"},
{"code":"Mdt rare"},
{"code":"Medicaments"},
{"code":"Menopause"},
{"code":"Migr"},
{"code":"Migraine occasionnelle"},
{"code":"Migraine ophtalmique"},
{"code":"Migraine rare"},
{"code":"Migraines"},
{"code":"Migraines occ."},
{"code":"Migraines ophtalmiques"},
{"code":"Miostonie"},
{"code":"Miostonie ?"},
{"code":"Moya Moya"},
{"code":"Moya-Moya"},
{"code":"Myasthénie grave"},
{"code":"Myeloide chronique"},
{"code":"Myopathie"},
{"code":"Mélanome"},
{"code":"Mémoire"},
{"code":"Ménopause"},
{"code":"Na plus de mdet"},
{"code":"Ne sait pas"},
{"code":"Nerf"},
{"code":"Nerf Arnold"},
{"code":"Neurofibromatose"},
{"code":"Neutropénie"},
{"code":"Nevralgie arnold"},
{"code":"Nevralgie trijumeau"},
{"code":"Nodules thyroide"},
{"code":"Noix"},
{"code":"Non-fumeur"},
{"code":"Normal"},
{"code":"Normale"},
{"code":"Normale/pas de MD"},
{"code":"Né à terme"},
{"code":"Névralgie"},
{"code":"Oesophagite"},
{"code":"Opere coeur"},
{"code":"Osler Weber Rendu"},
{"code":"Osteoporose"},
{"code":"Ovaire polykystique"},
{"code":"Pacemaker"},
{"code":"Paget"},
{"code":"Pancréatite"},
{"code":"Paralysie"},
{"code":"Paralysie Bell"},
{"code":"Paralysie cérébrale"},
{"code":"Paralysie faciale de longue date"},
{"code":"Parathyroïde"},
{"code":"Parkinson"},
{"code":"Pas CHL"},
{"code":"Pas CHL, DB"},
{"code":"Pas CHL, DB, thyroide"},
{"code":"Pas CHL, HTN"},
{"code":"Pas CHL, HTN, DB"},
{"code":"Pas CHL, HTN, DB, thyroide"},
{"code":"Pas CHL, HTN, thyroide"},
{"code":"Pas DB"},
{"code":"Pas DB, CHL, HTN"},
{"code":"Pas DB, asthme"},
{"code":"Pas DB, pb thyroïde"},
{"code":"Pas DB, thyroid"},
{"code":"Pas DB, thyroide"},
{"code":"Pas HTN"},
{"code":"Pas HTN, CHL, DB, thyroide"},
{"code":"Pas HTN, CHL, thyroide"},
{"code":"Pas HTN, DB"},
{"code":"Pas HTN, DB, Chol"},
{"code":"Pas HTN, DB, thyroid"},
{"code":"Pas HTN, DB, thyroide"},
{"code":"Pas HTN, choles, diab."},
{"code":"Pas HTN, choles."},
{"code":"Pas HTN, choles., diab."},
{"code":"Pas HTN, choles.,diab."},
{"code":"Pas HTN, diab"},
{"code":"Pas HTN, diab."},
{"code":"Pas HTN, diab. choles"},
{"code":"Pas HTN, diab., choles"},
{"code":"Pas HTN, diab., choles."},
{"code":"Pas HTN, diab.,choles."},
{"code":"Pas HTN,diab."},
{"code":"Pas HTN,diab., choles."},
{"code":"Pas Mdt/ aller"},
{"code":"Pas SEP"},
{"code":"Pas aller"},
{"code":"Pas asthme"},
{"code":"Pas chl, thyroide"},
{"code":"Pas chol"},
{"code":"Pas choles."},
{"code":"Pas choles. pas HTN"},
{"code":"Pas choles., HTN"},
{"code":"Pas cholesterol"},
{"code":"Pas db, CHL, HTN, thyroide"},
{"code":"Pas de DB"},
{"code":"Pas de DB, chol."},
{"code":"Pas de diab., choles"},
{"code":"Pas de mdt"},
{"code":"Pas de médecin"},
{"code":"Pas diab"},
{"code":"Pas diab, HTN"},
{"code":"Pas diab."},
{"code":"Pas diab., HTN"},
{"code":"Pas diab., HTN, choles"},
{"code":"Pas diab., HTN, choles."},
{"code":"Pas diab., choles."},
{"code":"Pas diplopie"},
{"code":"Pas fievre"},
{"code":"Pas mdet/allergie"},
{"code":"Pas pb thyroïde, DB"},
{"code":"Pas pb thyroïde, HTN"},
{"code":"Pas syndrome"},
{"code":"Pas thyroide"},
{"code":"Penecilline"},
{"code":"Periménaupose"},
{"code":"Perte de cheuveux"},
{"code":"Phlébite"},
{"code":"Piqure insecte"},
{"code":"Poils"},
{"code":"Poisson"},
{"code":"Pollen"},
{"code":"Polyarthrite"},
{"code":"Polyarthrite psioratique"},
{"code":"Polymyalgia rhumatica"},
{"code":"Polymyalgie rhumatoide"},
{"code":"Polyneuropathie"},
{"code":"Polyskystique"},
{"code":"Pompe nasale"},
{"code":"Poumon"},
{"code":"Poussiere"},
{"code":"Pre diabete"},
{"code":"Pre menopause"},
{"code":"Prematuré"},
{"code":"Prob De circulation"},
{"code":"Prob Gastrique"},
{"code":"Prob attention"},
{"code":"Prob coeur"},
{"code":"Prob coeur angine"},
{"code":"Prob d audition"},
{"code":"Prob renal congenital"},
{"code":"Prob. Cardiaques"},
{"code":"Prob. De circulation"},
{"code":"Prob. Gastrique"},
{"code":"Prob. intestinaux"},
{"code":"Prob. sinus"},
{"code":"Prob.poignet ligament"},
{"code":"Probl.rein"},
{"code":"Probleme globules rouges"},
{"code":"Probleme renaux"},
{"code":"Problemes intestinaux"},
{"code":"Problème immunitaire"},
{"code":"Prostate"},
{"code":"Pseudoephrédrine"},
{"code":"Psoriasis"},
{"code":"Reflux gastrique"},
{"code":"Rein"},
{"code":"Relaxant musculaire"},
{"code":"Remission"},
{"code":"Remission cancer hodgkin"},
{"code":"Retard de développement global"},
{"code":"Revient de thérapie"},
{"code":"Rhumatisme"},
{"code":"Rhume"},
{"code":"Rosacée"},
{"code":"Rythme cardiaque"},
{"code":"Rémidex"},
{"code":"Sang coagulation"},
{"code":"Santé générale 2"},
{"code":"Sarcoïdose"},
{"code":"Schizophrénie"},
{"code":"Sclerodermie"},
{"code":"Sclerose latérale amyotrophique (SLA)"},
{"code":"Scléroderma"},
{"code":"Sclérose en plaques"},
{"code":"Scoliose cervicale"},
{"code":"Septra"},
{"code":"Severage médicament"},
{"code":"Sinusite"},
{"code":"Sinusite chronique"},
{"code":"Sjogren"},
{"code":"Somnifère"},
{"code":"Souffle au coeur"},
{"code":"Spasme"},
{"code":"Spinabifita"},
{"code":"Spondylite ankylosante"},
{"code":"Stemt"},
{"code":"Stenose moelle cervicale"},
{"code":"Stenose spinale"},
{"code":"Streptocoque"},
{"code":"Sulfas"},
{"code":"Surdité"},
{"code":"Synd.ovaire polykystique"},
{"code":"Syndrome Aspergher"},
{"code":"Syndrome Pfeifer"},
{"code":"Syndrome chromosomiale"},
{"code":"Syndrome de Noonan"},
{"code":"Syndrome de horner congénital"},
{"code":"Syndrome de raynaud"},
{"code":"Syndrome de turner"},
{"code":"Syndrome gilles latourette"},
{"code":"Syndrome kawasaki"},
{"code":"Syndrome marfan"},
{"code":"Syndrome stevens johnson"},
{"code":"Syndrôme Marfan"},
{"code":"T.D.A."},
{"code":"T.S.A"},
{"code":"TDA limite"},
{"code":"TDA(H)"},
{"code":"TDAH"},
{"code":"Tachycardie"},
{"code":"Taghiasu (hypertension)"},
{"code":"Tendance migraine"},
{"code":"Tendinite"},
{"code":"Thrombocitémie"},
{"code":"Thrombophlébite"},
{"code":"Thyroid"},
{"code":"Thyroïde"},
{"code":"Thyroïde"},
{"code":"Thyroïde ?"},
{"code":"Torticolis"},
{"code":"Trachéotomie"},
{"code":"Tremblement"},
{"code":"Tremblement essentiel"},
{"code":"Triglycéride"},
{"code":"Trijumeau"},
{"code":"Trisomie"},
{"code":"Trouble TED"},
{"code":"Trouble bipolaire"},
{"code":"Trouble langage"},
{"code":"Tumeur hypophyse"},
{"code":"Tumeur sein"},
{"code":"Tylenol"},
{"code":"Tylenol PRN"},
{"code":"Urticaire"},
{"code":"VIH."},
{"code":"Varicelle"},
{"code":"Vert"},
{"code":"Vertige"},
{"code":"Vessie"},
{"code":"Vitiligo"},
{"code":"Voir liste"},
{"code":"Zinc PNC"},
{"code":"Zona"},
{"code":"Zytromax"},
{"code":"Éclaircir sang"},
]
